export default class StringBuffer {
  data: string[];

  constructor() {
    this.data = [];
  }

  append(s: string): void {
    this.data.push(s);
  }

  toString(): string {
    return this.data.join('');
  }
}
